module.exports = __webpack_public_path__ + "static/media/trial3_1.b879f9a1.png";